import React, {useState,useEffect,useContext} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso,Loading,ModalFactureVision} from '@gull'
import axios from 'axios';
import swal from "sweetalert2";
import { IsAuthContext } from 'app/App';
import NameDossier from './CompDetailDossier/NameDossier'
import ClientDossier from './CompDetailDossier/ClientDossier'
import MemoDossier from './CompDetailDossier/MemoDossier'
import DossierListDocumentTable from './CompDetailDossier/DossierListDocumentTable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons'; 

const useLoad = (folderId) =>{
    const t = useTranslate();
    const [loading,setLoading]=useState(true)
    const [folderDetail,setFolderDetail] = useState({}) 
    const [reload,setReload] = useState(Date.now()) 

    useEffect(function () {
        (async function() {
            if(folderId){
                setLoading(true)
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/facture/dossier_b2b/get_one/"+folderId
                ).then((response) => {
                    if(!response.data.valid){
                        let interms='';
                        var keys = Object.keys(response.data.errors);
                        for(var i = 0; i < keys.length; i++){
                            interms+=response.data.errors[keys[i]].join(',')+','
                        }
                        interms=interms.split(',')
                        let messageError='';
                        interms.forEach(interm=>messageError+=t(interm)+'. ')
                        messageError=messageError.replace('undefined','');
                        swal.fire(messageError, "", "error");
                        setLoading(false)
                    }
                    else{   
                        setFolderDetail(response.data.data)
                        setLoading(false)
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                    swal.fire(t(errorName), "", "error");
                    setLoading(false)
                })
            }
        })()
    }, [folderId,reload])

    return [loading,setLoading,folderDetail,setFolderDetail,setReload]
}

const DetailDossierFactureListe = (props) => {
    const t = useTranslate();
    // const { id } = useParams();
    const { authParam } = useContext(IsAuthContext);
    const [loading,setLoading,folderDetail,setFolderDetail,setReload] = useLoad(props.folderId)
    const [onEdit,setOnEdit] = useState({
        name:false,
        memo:false
    })

    const [editState,setEditState] = useState(false)
    const [folderState,setFolderState] = useState(false)
    const [validButton,setValidButton] = useState(false)
    const [documentModal,setDocumentModal]=useState(false)
    const [selectedDocumentId,setSelectedDocumentId]=useState(false)
    const [titleDocument,setTitleDocument]=useState(false)
    const [brownDocumentModal,setBrownDocumentModal]=useState(false)

    let devise = authParam.company.devise;
    let digit = (authParam.company.advanceparams.hasOwnProperty('ventilation_espece') && authParam.company.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    let stateColor = (folderDetail.status == 0) ? {color:'#FF0000'} : {color:'#1ac632'}

    const handleEdit = (name) =>{
        setOnEdit({...onEdit,[name]:!onEdit[name]})
    }

    const onSubmit = async (setValidButton,data) => {
        setValidButton(true)

        const response  = await axios.put(process.env.REACT_APP_API_URL+"api/facture/dossier_b2b/edit/"+folderDetail.id, data
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }else{ 
                setFolderDetail(response.data.data)
                setOnEdit({
                    name:false,
                    memo:false
                })
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError
            if(error.response==undefined){
                messageError='unknowError'
            }
            else if(error.response.status==403){
                messageError='forbiddenGeneral'
            }
            else {
                messageError='unknowError'
            }
            swal.fire(t(messageError), "", "error");
        })
        setValidButton(false)
    };

    const folderStateSubmit = async () => {
        setValidButton(true)

        let obj = {
            status : folderState
        }

        const response  = await axios.put(process.env.REACT_APP_API_URL+"api/facture/dossier_b2b/edit/"+folderDetail.id,obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }else{ 
                setFolderDetail(response.data.data)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError
            if(error.response==undefined){
                messageError='unknowError'
            }
            else if(error.response.status==403){
                messageError='forbiddenGeneral'
            }
            else {
                messageError='unknowError'
            }
            swal.fire(t(messageError), "", "error");
        })

        setEditState(false)
        setValidButton(false)
    };

    const closeDocumentModal = () => {
        setDocumentModal(false)
        setReload(Date.now())
    }

    if(loading && props.bigLoader){
        return(
            <Loading></Loading>
        )
    }

    return(
        <div>
            {loading ? 
                <div className='d-flex justify-content-center mt-3'><div className="spinner-border spinner-border-sm"></div></div>
            :
                <>
                    <ModalFactureVision
                        documentModal={documentModal}
                        closeDocumentModal={closeDocumentModal}
                        titleDocument={titleDocument}
                        selectedDocumentId={selectedDocumentId}
                        setSelectedDocumentId={setSelectedDocumentId}
                        setTitleDocument={setTitleDocument}
                        brownDocumentModal={brownDocumentModal}
                        setBrownDocumentModal={setBrownDocumentModal}
                    />
                    <div className="row">
                        <div className="col-6">
                            <div className='row'>
                                <div className='col-9'>
                                    <h3 className='fw-bold'>{t('folder')+' n° '+folderDetail.nbr}</h3>
                                    <NameDossier 
                                        folderDetail={folderDetail} 
                                        onEdit={onEdit} 
                                        handleEdit={handleEdit}
                                        onSubmit={onSubmit}
                                    />
                                </div>
                                <div className='col-3'>
                                    <label className='fs-6 text fw-bold' htmlFor="state">{t('state')+' :'}</label><br/>
                                    {(!editState) ?
                                        <span className='fs-6 text' style={stateColor}>
                                            {(folderDetail.status == 0) ? t('open') : t('completed')} 
                                            <span>&nbsp;
                                                <FontAwesomeIcon 
                                                    icon={faEdit} 
                                                    className='text-primary pointer' 
                                                    onClick={()=>setEditState(true)}
                                                />
                                            </span>
                                        </span>
                                    :
                                        <div className='row'>
                                            <div className='col'>
                                                <div className='row mb-1'>
                                                    <div className='col'>
                                                        <select id='state' className="form-control form-control" defaultValue={folderDetail.status} onChange={(e)=>setFolderState(e.target.value)}> 
                                                            <option value={0}>{t('open')}</option>
                                                            <option value={1}>{t('completed')}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col'>
                                                        <button disabled={validButton} className="btn btn-sm btn-primary" onClick={()=>folderStateSubmit()}>
                                                            {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="row">
                                <div className='col-3 form-group'>
                                    <label>{t('company')}</label>
                                    <div>{folderDetail.other_company!=null ? folderDetail.other_company.name : authParam.company.name}</div>
                                </div>
                                <div className='col-6 form-group'>
                                    <label>{t('customer')}</label>
                                    <ClientDossier
                                        folderDetail={folderDetail}
                                        linkOnCLient={props.linkOnCLient}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div>
                            <CardPerso header='Memo'>
                                <MemoDossier 
                                    folderDetail={folderDetail} 
                                    onEdit={onEdit} 
                                    handleEdit={handleEdit}
                                    onSubmit={onSubmit}
                                />
                            </CardPerso>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div>
                            <CardPerso header={t('allDocuments')}>
                                <DossierListDocumentTable 
                                    folderDetail={folderDetail} 
                                    devise={devise} 
                                    digit={digit}
                                    setReload={setReload}
                                    from={props.from}
                                    authParam={authParam}
                                    currentId={(props.id) ? props.id : selectedDocumentId}
                                    setId={(props.setId) ? props.setId : setSelectedDocumentId}
                                    setTitleDocument={(props.setTitleDocument) ? props.setTitleDocument : setTitleDocument}
                                    setDocumentModal={setDocumentModal}
                                />
                            </CardPerso>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default DetailDossierFactureListe;